module.exports = __webpack_public_path__ + "static/media/camera-polaroid.9f7331bc.svg";